<script lang="ts">
    import {onMount} from "svelte"
    import {isLoggedIn, session, userProfile} from "src/services/auth"
    import {navigate} from "src/global/navigate"
    import TwoFactor from 'src/components/cabinet/two-factor/TwoFactor.svelte'

    let mounted = false
    export let redirectUnAuth: string
    export let redirectBan: string

    onMount(() => {
        mounted = true
    })

    $: if (mounted) {
        if ($userProfile && $userProfile.isBanned) {
            navigate(redirectBan)
        } else if (!$isLoggedIn) {
            navigate(redirectUnAuth)
        }
    }
</script>

{#if !$isLoggedIn}
    <!-- svelte может выдавать ошибки при вложенных if else -->
{:else if $session?.isNeed2fa}
    <TwoFactor/>
{:else}
    <slot></slot>
{/if}
